import { useMemo } from "react";
import { IRevenueData, RevenueFilterState } from "./ConsumptionRevenueTab.interfaces";

export const useRevenueFilters = (
  data: IRevenueData | undefined,
  currentFilter: RevenueFilterState
) => {
  return useMemo(() => {
    if (!data?.revenueList) return [];

    // Filter to last 12 months based on endOfMonth
    const now = new Date();
    const twelveMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 11, 1);
    let filtered = data.revenueList.filter((item) => {
      const billingDate = new Date(item.endOfMonth);
      return billingDate >= twelveMonthsAgo && billingDate <= now;
    });

    if (currentFilter.filterKey && currentFilter.value) {
      const { filterKey, value } = currentFilter;
      filtered = filtered.filter((item) => String(item[filterKey]).trim() === value.trim());
    }

    return filtered;
  }, [data, currentFilter]);
};
